"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
   * ------------------------------------------------------------------------
   * Polyfills
   * ------------------------------------------------------------------------
   */
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

(function () {
  if (typeof window.CustomEvent === "function") return false;

  function CustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: null
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  window.CustomEvent = CustomEvent;
})();
/**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */


var Default = {
  rating: 0,
  readOnly: false,
  enableTooltips: true
};
var Selector = {
  RATING_OPTION: '.rating-option',
  RATING_INPUT: '.rating-input',
  TOOLTIP: '[data-toggle="tooltip"]'
};
var ClassName = {
  ACTIVE: 'active'
};
/**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

var EsStarRating = /*#__PURE__*/function () {
  function EsStarRating(element, config) {
    _classCallCheck(this, EsStarRating);

    this._element = document.querySelector(element);
    this._ratingOptions = this._element.querySelectorAll(Selector.RATING_OPTION);
    this._config = this._getConfig(config);
    this._rating = this._config.rating;
    this._prevRating = this._config.rating;
    this._config.readOnly ? this.disableRating() : this._bindEventHandlers();

    if (this._config.rating) {
      this._setRating();
    } // Tooltip-related assignments and functions


    if (this._config.enableTooltips) {
      this._tooltips = Array.from(this._element.querySelectorAll(Selector.TOOLTIP));
      this._stars = Array.from(this._element.querySelectorAll(Selector.RATING_INPUT));
      this.enableTooltips(this._tooltips);

      this._handleTooltipFocus();
    }
  } // Public

  /**
   * Bootstrap notes: How tooltip is triggered - click | hover | focus | manual. You may pass multiple triggers; separate them with a space.
   * For ESBS: Should be hover and focus. But focus only for keyboard users.
   * And hover only until the user makes a selection/clicks.
   */


  _createClass(EsStarRating, [{
    key: "enableTooltips",
    value: function enableTooltips(tooltipList) {
      tooltipList.forEach(function (tooltip) {
        $(tooltip).tooltip();
      });
    }
  }, {
    key: "disableRating",
    value: function disableRating() {
      this._ratingOptions.forEach(function (option) {
        option.querySelector(Selector.RATING_INPUT).setAttribute("disabled", true);
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this._setRating(0);

      this._dispatchRatingEvent();
    } // Private

  }, {
    key: "_getConfig",
    value: function _getConfig(config) {
      config = _objectSpread(_objectSpread({}, Default), _typeof(config) === 'object' && config ? config : {});
      return config;
    }
  }, {
    key: "_bindEventHandlers",
    value: function _bindEventHandlers() {
      var _this = this;

      this._ratingOptions.forEach(function (option, index) {
        option.addEventListener('mouseover', function () {
          _this._onMouseOver(index);
        });
        option.addEventListener('mouseleave', function () {
          _this._setRating();
        });
        option.addEventListener('keydown', function (evt) {
          _this._onRatingKeydown(evt);
        });
        option.addEventListener('keyup', function (evt) {
          _this._onRatingKeyup(evt, index);
        });
        option.addEventListener('mouseup', function (evt) {
          _this._onRatingClick(evt, index);
        });
        option.querySelector(Selector.RATING_INPUT).addEventListener('change', function () {
          _this._onInputChange(index);
        });
      });
    }
  }, {
    key: "_onMouseOver",
    value: function _onMouseOver(index) {
      this._ratingOptions.forEach(function (option, i) {
        option.classList.remove(ClassName.ACTIVE);

        if (i <= index) {
          option.classList.add(ClassName.ACTIVE);
        }
      });
    }
  }, {
    key: "_setRating",
    value: function _setRating(rating) {
      var _this2 = this;

      if (rating !== undefined) {
        this._rating = rating;
      }

      this._ratingOptions.forEach(function (option, i) {
        option.classList.remove(ClassName.ACTIVE);

        if (i <= _this2._rating - 1) {
          option.classList.add(ClassName.ACTIVE);
        }

        if (i === _this2._rating - 1) {
          option.querySelector(Selector.RATING_INPUT).checked = true;
        }
      });
    }
  }, {
    key: "_onInputChange",
    value: function _onInputChange(index) {
      this._setRating(index + 1);
    }
  }, {
    key: "_onRatingKeydown",
    value: function _onRatingKeydown(evt) {
      var key = evt.key || evt.keyCode;

      if (key === 'Tab' || key === '9') {
        if (this._prevRating !== this._rating) {
          this._prevRating = this._rating;

          this._dispatchRatingEvent();
        }
      }
    }
  }, {
    key: "_onRatingKeyup",
    value: function _onRatingKeyup(evt, index) {
      var key = evt.key || evt.keyCode;

      if (key === ' ' || key === '32') {
        if (!this._rating) {
          this._rating = index + 1;
        }

        if (this._prevRating !== this._rating) {
          this._prevRating = this._rating;

          this._dispatchRatingEvent();
        }
      }
    }
  }, {
    key: "_onRatingClick",
    value: function _onRatingClick(evt, index) {
      if (index + 1 !== this._rating) {
        this._setRating(index + 1);

        var input = evt.target.tagName === 'INPUT' ? evt.target : evt.target.querySelector(Selector.RATING_INPUT);

        if (document.activeElement !== input) {
          input.focus();
        }

        this._prevRating = this._rating;

        this._dispatchRatingEvent();
      }
    }
  }, {
    key: "_dispatchRatingEvent",
    value: function _dispatchRatingEvent() {
      var ratingSelectedEvent = new CustomEvent('rating-set', {
        detail: {
          rating: this._rating
        }
      });

      this._element.dispatchEvent(ratingSelectedEvent);
    } // TODO: Should we break this up or place elsewhere?

  }, {
    key: "_handleTooltipFocus",
    value: function _handleTooltipFocus(e) {
      var _this3 = this;

      this._tooltips.forEach(function (tooltip) {
        $(tooltip).on('show.bs.tooltip', function () {
          var tooltipsToHide = _this3._tooltips.filter(function (tooltipToFilter) {
            return tooltipToFilter != tooltip;
          });

          tooltipsToHide.forEach(function (tooltip) {
            $(tooltip).tooltip('hide');
          });
        });
        tooltip.addEventListener('mouseup', function () {
          $(tooltip).tooltip('hide');
        });
      });
    }
  }]);

  return EsStarRating;
}();